var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartphoneFrauOhneGrenzenCombi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1425.3 1310.6",
    style: {
      enableBackground: "new 0 0 1425.3 1310.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#137F7B;}\n\t.st1{fill:#B2B6BB;}\n\t.st2{fill:#61656D;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#868A91;}\n\t.st5{fill:#21252B;}\n\t.st6{fill:#DADDDF;}\n\t.st7{opacity:0.8;fill:#FFFFFF;enable-background:new    ;}\n\t.st8{fill:#006666;}\n\t.st9{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}\n\t.st10{opacity:0.6;fill:#FFFFFF;enable-background:new    ;}\n\t.st11{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\n\t.st12{fill:#FC9D9D;}\n\t.st13{opacity:0.15;}\n\t.st14{opacity:0.15;enable-background:new    ;}\n\t.st15{opacity:0.6;enable-background:new    ;}\n\t.st16{opacity:0.2;}\n\t.st17{opacity:0.2;enable-background:new    ;}\n\t.st18{fill:#3F4249;}\n\t.st19{fill:#F99A9A;}\n\t.st20{opacity:0.6;}\n\t.st21{opacity:0.3;enable-background:new    ;}\n\t.st22{fill:#60BBB3;}\n\t.st23{fill:#0F807C;}\n\t.st24{fill:none;stroke:#015B58;stroke-width:3;stroke-miterlimit:10;}\n\t.st25{fill:none;stroke:#015B58;stroke-width:3;stroke-miterlimit:10;stroke-dasharray:15.3299,8.176;}\n\t.st26{fill:none;stroke:#015B58;stroke-width:3;stroke-miterlimit:10;stroke-dasharray:14.8645,7.9277;}\n\t.st27{fill:none;stroke:#015B58;stroke-width:3;stroke-miterlimit:10;stroke-dasharray:10.0301,5.3494;}\n\t.st28{fill:none;stroke:#015B58;stroke-width:3;stroke-miterlimit:10;stroke-dasharray:10.8264,5.7741;}\n\t.st29{fill:none;stroke:#015B58;stroke-width:3;stroke-miterlimit:10;stroke-dasharray:12.2835,6.5512;}\n\t.st30{fill:#015B58;stroke:#015B58;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2_00000041254306604573215230000002023447759256322998_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M554.1,248.4c210.6,0,382.1,171.5,382.1,382.1s-171.5,382.1-382.1,382.1S172,841.1,172,630.6 S343.6,248.4,554.1,248.4 M554.1,240.3c-215.5,0-390.3,174.8-390.3,390.3s174.8,390.3,390.3,390.3S944.4,846,944.4,630.6 S769.6,240.3,554.1,240.3L554.1,240.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 226.3,
    cy: 246.1,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 326.3,
    cy: 246.1,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 426.4,
    cy: 246.1,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 526.5,
    cy: 246.1,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 626.5,
    cy: 246.1,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 226.3,
    cy: 346.2,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 326.3,
    cy: 346.2,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 426.4,
    cy: 346.2,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 526.5,
    cy: 346.2,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 626.5,
    cy: 346.2,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 226.3,
    cy: 446.3,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 326.3,
    cy: 446.3,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 426.4,
    cy: 446.3,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 526.5,
    cy: 446.3,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 626.5,
    cy: 446.3,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 226.3,
    cy: 546.3,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 326.3,
    cy: 546.3,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 426.4,
    cy: 546.3,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 526.5,
    cy: 546.3,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 626.5,
    cy: 546.3,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 226.3,
    cy: 646.4,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 326.3,
    cy: 646.4,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 426.4,
    cy: 646.4,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 526.5,
    cy: 646.4,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 626.5,
    cy: 646.4,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 226.3,
    cy: 746.5,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 326.3,
    cy: 746.5,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 426.4,
    cy: 746.5,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 526.5,
    cy: 746.5,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 626.5,
    cy: 746.5,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 226.3,
    cy: 846.5,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 326.3,
    cy: 846.5,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 426.4,
    cy: 846.5,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 526.5,
    cy: 846.5,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 626.5,
    cy: 846.5,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 226.3,
    cy: 946.6,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 326.3,
    cy: 946.6,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 426.4,
    cy: 946.6,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 526.5,
    cy: 946.6,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 626.5,
    cy: 946.6,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 226.3,
    cy: 1046.7,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 326.3,
    cy: 1046.7,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 426.4,
    cy: 1046.7,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 526.5,
    cy: 1046.7,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 626.5,
    cy: 1046.7,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 226.3,
    cy: 1146.7,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 326.3,
    cy: 1146.7,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 426.4,
    cy: 1146.7,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 526.5,
    cy: 1146.7,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 626.5,
    cy: 1146.7,
    r: 6.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1048.7,808.6H432.9V403.7c0-6.7,5.4-12.1,12.1-12.1h591.6c6.7,0,12.1,5.4,12.1,12.1V808.6L1048.7,808.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1043.1,800.5H427.3V403.7c0-6.7,5.4-12.1,12.1-12.1h591.5c6.7,0,12.1,5.4,12.1,12.1L1043.1,800.5 L1043.1,800.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1022,413.2H448.3v365.6H1022V413.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1044.7,800.5H808.4c-2.2,0-4,1.8-4,4v12.8c4.4,5.8,11.3,9.1,18.5,9.1h207.2c3.3,0,6.4-0.7,9.3-1.9 c5.6-2.4,9.2-8.1,9.2-14.2v-5.7C1048.7,802.3,1046.9,800.5,1044.7,800.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M888.8,800.5h-598c-2.2,0-4,1.8-4,4v5.7c0,6.1,3.6,11.8,9.2,14.2c2.9,1.3,6.1,2,9.3,2h569c3.3,0,6.4-0.7,9.4-2 c5.6-2.4,9.2-8.1,9.2-14.2v-5.7C892.9,802.3,891.1,800.5,888.8,800.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M636.2,811h-92.7c-6.8,0-13-4.2-15.5-10.5h123.7C649.1,806.8,643,811,636.2,811z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1022,413.2H448.3v32.6H1022V413.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1025.8,413.2H452.1v32.6h573.7V413.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464.2,435.4c3.8,0,6.9-3.1,6.9-6.9s-3.1-6.9-6.9-6.9s-6.9,3.1-6.9,6.9S460.4,435.4,464.2,435.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M489.1,435.4c3.8,0,6.9-3.1,6.9-6.9s-3.1-6.9-6.9-6.9s-6.9,3.1-6.9,6.9S485.3,435.4,489.1,435.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M513.9,435.4c3.8,0,6.9-3.1,6.9-6.9s-3.1-6.9-6.9-6.9s-6.9,3.1-6.9,6.9S510.1,435.4,513.9,435.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M930.2,487.9H586.1c-3.1,0-5.6-2.5-5.6-5.6v-16.6c0-3.1,2.5-5.6,5.6-5.6h344.1c3.1,0,5.6,2.5,5.6,5.6v16.6 C935.8,485.4,933.3,487.9,930.2,487.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M922,470.1c-2-2-5.4-2-7.4,0c-2.1,2-2.1,5.4,0,7.4c1.9,1.9,4.8,2,6.9,0.5l2.9,2.9l1-1l-2.9-2.9 C924,474.9,923.8,472,922,470.1z M921,476.5c-1.5,1.5-3.9,1.5-5.4,0s-1.5-3.9,0-5.4s3.9-1.5,5.4,0C922.4,472.6,922.4,475,921,476.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M967.8,469.4h-15.6v1.5h15.6V469.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M967.8,474.9h-15.6v1.5h15.6V474.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M967.8,480.3h-15.6v1.5h15.6V480.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M995.6,485.5c6.4,0,11.5-5.1,11.5-11.5s-5.1-11.5-11.5-11.5s-11.5,5.1-11.5,11.5 C984.1,480.3,989.3,485.5,995.6,485.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M995.6,474.2c2.2,0,4.1-1.8,4.1-4.1c0-2.2-1.8-4.1-4.1-4.1s-4.1,1.8-4.1,4.1S993.4,474.2,995.6,474.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1004.9,480.7c-2.1,2.9-5.5,4.8-9.3,4.8s-7.2-1.9-9.3-4.8c0.5-3.1,3.1-5.3,6.3-5.3h6.1 C1001.8,475.4,1004.4,477.7,1004.9,480.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M995.6,474.2c2.2,0,4.1-1.8,4.1-4.1c0-2.2-1.8-4.1-4.1-4.1s-4.1,1.8-4.1,4.1S993.4,474.2,995.6,474.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1004.9,480.7c-2.1,2.9-5.5,4.8-9.3,4.8s-7.2-1.9-9.3-4.8c0.5-3.1,3.1-5.3,6.3-5.3h6.1 C1001.8,475.4,1004.4,477.7,1004.9,480.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M483.7,546.3h-13.8c-2.3,0-4.2-1.9-4.2-4.2v-13.2c0-2.3,1.9-4.2,4.2-4.2h13.8c2.3,0,4.2,1.9,4.2,4.2v13.2 C488,544.4,486.1,546.3,483.7,546.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M565.3,539.6h-64.5c-1.2,0-2.1-0.9-2.1-2.1v-4.2c0-1.2,0.9-2.1,2.1-2.1h64.5c1.2,0,2.1,0.9,2.1,2.1v4.2 C567.3,538.7,566.4,539.6,565.3,539.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M565.3,589.5h-64.5c-1.2,0-2.1-0.9-2.1-2.1v-4.2c0-1.2,0.9-2.1,2.1-2.1h64.5c1.2,0,2.1,0.9,2.1,2.1v4.2 C567.3,588.6,566.4,589.5,565.3,589.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M565.3,639.4h-64.5c-1.2,0-2.1-0.9-2.1-2.1v-4.2c0-1.2,0.9-2.1,2.1-2.1h64.5c1.2,0,2.1,0.9,2.1,2.1v4.2 C567.3,638.4,566.4,639.4,565.3,639.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M565.3,689.3h-64.5c-1.2,0-2.1-0.9-2.1-2.1V683c0-1.2,0.9-2.1,2.1-2.1h64.5c1.2,0,2.1,0.9,2.1,2.1v4.2 C567.3,688.3,566.4,689.3,565.3,689.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M565.3,739.1h-64.5c-1.2,0-2.1-0.9-2.1-2.1v-4.2c0-1.2,0.9-2.1,2.1-2.1h64.5c1.2,0,2.1,0.9,2.1,2.1v4.2 C567.3,738.2,566.4,739.1,565.3,739.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M483.7,596.1h-13.8c-2.3,0-4.2-1.9-4.2-4.2v-13.2c0-2.3,1.9-4.2,4.2-4.2h13.8c2.3,0,4.2,1.9,4.2,4.2v13.2 C488,594.2,486.1,596.1,483.7,596.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M483.7,646h-13.8c-2.3,0-4.2-1.9-4.2-4.2v-13.2c0-2.3,1.9-4.2,4.2-4.2h13.8c2.3,0,4.2,1.9,4.2,4.2v13.2 C488,644.1,486.1,646,483.7,646z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M483.7,695.9h-13.8c-2.3,0-4.2-1.9-4.2-4.2v-13.2c0-2.3,1.9-4.2,4.2-4.2h13.8c2.3,0,4.2,1.9,4.2,4.2v13.2 C488,694,486.1,695.9,483.7,695.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M483.7,745.8h-13.8c-2.3,0-4.2-1.9-4.2-4.2v-13.2c0-2.3,1.9-4.2,4.2-4.2h13.8c2.3,0,4.2,1.9,4.2,4.2v13.2 C488,743.9,486.1,745.8,483.7,745.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.7,546.3h-13.8c-2.3,0-4.2-1.9-4.2-4.2v-13.2c0-2.3,1.9-4.2,4.2-4.2h13.8c2.3,0,4.2,1.9,4.2,4.2v13.2 C488,544.4,486.1,546.3,483.7,546.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M565.3,539.6h-64.5c-1.2,0-2.1-0.9-2.1-2.1v-4.2c0-1.2,0.9-2.1,2.1-2.1h64.5c1.2,0,2.1,0.9,2.1,2.1v4.2 C567.3,538.7,566.4,539.6,565.3,539.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M565.3,589.5h-64.5c-1.2,0-2.1-0.9-2.1-2.1v-4.2c0-1.2,0.9-2.1,2.1-2.1h64.5c1.2,0,2.1,0.9,2.1,2.1v4.2 C567.3,588.6,566.4,589.5,565.3,589.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M565.3,639.4h-64.5c-1.2,0-2.1-0.9-2.1-2.1v-4.2c0-1.2,0.9-2.1,2.1-2.1h64.5c1.2,0,2.1,0.9,2.1,2.1v4.2 C567.3,638.4,566.4,639.4,565.3,639.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M565.3,689.3h-64.5c-1.2,0-2.1-0.9-2.1-2.1V683c0-1.2,0.9-2.1,2.1-2.1h64.5c1.2,0,2.1,0.9,2.1,2.1v4.2 C567.3,688.3,566.4,689.3,565.3,689.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M565.3,739.1h-64.5c-1.2,0-2.1-0.9-2.1-2.1v-4.2c0-1.2,0.9-2.1,2.1-2.1h64.5c1.2,0,2.1,0.9,2.1,2.1v4.2 C567.3,738.2,566.4,739.1,565.3,739.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.7,596.1h-13.8c-2.3,0-4.2-1.9-4.2-4.2v-13.2c0-2.3,1.9-4.2,4.2-4.2h13.8c2.3,0,4.2,1.9,4.2,4.2v13.2 C488,594.2,486.1,596.1,483.7,596.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.7,646h-13.8c-2.3,0-4.2-1.9-4.2-4.2v-13.2c0-2.3,1.9-4.2,4.2-4.2h13.8c2.3,0,4.2,1.9,4.2,4.2v13.2 C488,644.1,486.1,646,483.7,646z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.7,695.9h-13.8c-2.3,0-4.2-1.9-4.2-4.2v-13.2c0-2.3,1.9-4.2,4.2-4.2h13.8c2.3,0,4.2,1.9,4.2,4.2v13.2 C488,694,486.1,695.9,483.7,695.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.7,745.8h-13.8c-2.3,0-4.2-1.9-4.2-4.2v-13.2c0-2.3,1.9-4.2,4.2-4.2h13.8c2.3,0,4.2,1.9,4.2,4.2v13.2 C488,743.9,486.1,745.8,483.7,745.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1022,501.7H448.3v0.7H1022V501.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M580.9,502.1h-0.7v276.8h0.7V502.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M580.5,560H448.3v0.7h132.2V560z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M580.5,609.9H448.3v0.7h132.2V609.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M580.5,659.8H448.3v0.7h132.2V659.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M580.5,709.7H448.3v0.7h132.2V709.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M580.5,759.5H448.3v0.7h132.2V759.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M858,215.9c0.1-1.6,0.2-3.3,0.2-4.9c0-40.7-33-73.7-73.7-73.7c-30.6,0-56.9,18.6-68,45.2 c-3.6-1.2-7.4-1.8-11.3-1.8c-18.7,0-34.2,14-36.4,32.2c-24.5,4.5-43,26-43,51.8c0,29.1,23.6,52.6,52.6,52.6h159.7 c29.1,0,52.6-23.6,52.6-52.6C890.7,242.6,877.2,223.8,858,215.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M508.7,159.1l22.9-15.7c1.1-0.7,2.5-0.8,3.6-0.2l8.5,4.3l52.2-35.9c1.6-1.1,3.8-0.7,4.9,0.9l38.2,55.7 c1,1.5,0.6,3.5-0.8,4.5l-81.9,56.2c-1.5,1-3.5,0.6-4.5-0.8l-44.1-64.2C506.7,162.3,507.1,160.2,508.7,159.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M640.5,169.6l-17.7-58.8c-0.5-1.5-2.3-2.2-3.6-1.3l-82.6,56.8c-1.1,0.8-1.6,2.2-1.2,3.5l17.6,58.6 c0.4,1.2,1.8,1.7,2.8,1l84-57.7C640.4,171.2,640.7,170.4,640.5,169.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M640.5,169.6l-17.7-58.8c-0.5-1.5-2.3-2.2-3.6-1.3l-82.6,56.8c-1.1,0.8-1.6,2.2-1.2,3.5l17.6,58.6 c0.4,1.2,1.8,1.7,2.8,1l84-57.7C640.4,171.2,640.7,170.4,640.5,169.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M640.5,169.6l-17.7-58.8L640.5,169.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M921.8,167.3l-65.9-8.6c-2.2-0.3-3.8-2.3-3.5-4.5l11-84.8c0.3-2.2,2.3-3.8,4.5-3.5l65.8,8.5 c2.2,0.3,3.8,2.3,3.5,4.5l-10.9,85C926.1,166.1,924,167.6,921.8,167.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M921.8,167.3l-65.9-8.6c-2.2-0.3-3.8-2.3-3.5-4.5l11-84.8c0.3-2.2,2.3-3.8,4.5-3.5l65.8,8.5 c2.2,0.3,3.8,2.3,3.5,4.5l-10.9,85C926.1,166.1,924,167.6,921.8,167.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M927.8,163.6l-64.2-24.5c-1.5-0.6-2.3-2.3-1.7-3.8l31.2-81.9c0.6-1.5,2.3-2.3,3.8-1.7l47,17.9l12.3,27.8 l-24.6,64.5C931,163.4,929.3,164.1,927.8,163.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M927.8,163.6l-64.2-24.5c-1.5-0.6-2.3-2.3-1.7-3.8l31.2-81.9c0.6-1.5,2.3-2.3,3.8-1.7l47,17.9l12.3,27.8 l-24.6,64.5C931,163.4,929.3,164.1,927.8,163.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M956.2,97.4L939,90.8c-1.5-0.6-2.3-2.3-1.7-3.8l6.6-17.4L956.2,97.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M956.2,97.4L939,90.8c-1.5-0.6-2.3-2.3-1.7-3.8l6.6-17.4L956.2,97.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M907.4,66l-7.8-3l-7,18.4l7.8,3L907.4,66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M911.9,77.4l-7.8-3l-3.8,9.9l7.8,3L911.9,77.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M941.3,110l-52.1-19.9l-1.6,4.2l52.1,19.9L941.3,110z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M935.2,126.1l-52.1-19.9l-1.6,4.2l52.1,19.9L935.2,126.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M913.5,136.3l-36.6-13.9l-1.6,4.2l36.6,13.9L913.5,136.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1181.2,608.7l-0.4-9.2c-0.1-1.6-0.7-3.2-1.7-4.5l-3.2-3.8c-0.8-1-2.2-1.5-3.4-1.2l-7.4,1.7 c-0.4,0.1-0.6,0.4-0.6,0.8c0.1,2,1.7,3.5,3.7,3.7l4.5,0.3l0.8,1.7c0.1,0.2,0.1,0.4,0.1,0.7l-1.5,3c-1,1.9-3.5,2.5-5.2,1.1l-2.6-2.1 l-4.3,8l2.3,4.3c1.3,2.4,3.6,4,6.2,4.5l1,0.2c0.5,0.1,1,0.4,1.3,0.8l4.2,6l11.1-9.1l-4.4-5.7 C1181.4,609.5,1181.3,609.1,1181.2,608.7z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1176.6,592.1c1.1,1.3,1.7,2.8,1.7,4.5l0.4,14.8c0,0.4,0.1,0.8,0.4,1.1l3.9,5.6l3-2.5l-4.4-5.7 c-0.2-0.3-0.4-0.7-0.4-1.1l-0.4-9.2c-0.1-1.6-0.7-3.2-1.7-4.5l-3.2-3.8c-0.1-0.1-0.2-0.2-0.3-0.4L1176.6,592.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1232.2,645.7l-9.7,9.2l-38.1-41.4l-12.1,7.5l37.3,58.4c5.2,8.1,16.6,9.2,23.2,2.2l21-22.4L1232.2,645.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1159.8,596.5l-0.8,10.6l-11.7-21.7c-0.6-1.2-0.2-2.6,0.9-3.3c1.2-0.7,2.7-0.3,3.4,0.8L1159.8,596.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1151.5,582.9c-0.6-0.9-1.6-1.3-2.6-1.1c0.3,0.2,0.6,0.5,0.8,0.8l4.8,8c0.5,0.9,0.9,1.9,1,3l1.1,9.4l2.2,4.1 l0.8-10.6L1151.5,582.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1167.9,606.3l-2.9-2.2l-0.2-0.4l-0.7,6l0.5,0.1l0.3-2.6c0.3,0.7,0.9,1.2,1.7,1.4h2.2L1167.9,606.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1143.3,563.6l-1,0.6c-0.9,0.5-1.2,1.7-0.6,2.6l26.1,42.2c0.5,0.9,1.7,1.2,2.6,0.6l1.4-1 c0.8-0.6,1.1-1.7,0.6-2.6l-26.6-41.9C1145.3,563.3,1144.2,563,1143.3,563.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1155.4,586l2.1,18.2l4.9,9l0.6-5.7l-2.9-22c-0.2-1.2-1.2-2.1-2.4-2.1C1156.3,583.4,1155.2,584.7,1155.4,586z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1161.8,595.5l-2.2,11.4l3.6,5.7l1.9-16.7c0.1-0.7-0.2-1.3-0.8-1.6C1163.3,593.7,1162,594.3,1161.8,595.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1161.6,596.5l-1.5,7.8l0.6-14.9L1161.6,596.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1184.5,613.5l2.2,2.4l-12.5,7.9l-1.8-2.8L1184.5,613.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1218.2,683.1c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6 C1216.5,682.3,1217.3,683.1,1218.2,683.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1239,540.9c9.4,0,17-7.6,17-17s-7.6-17-17-17s-17,7.6-17,17C1222,533.3,1229.6,540.9,1239,540.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M766.4,778.2l-10-2.2c-1.7-0.4-3.3,0.9-3.3,2.7c0,1.1,0.7,2.1,1.7,2.5l12.2,5L766.4,778.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M766.4,778.2l-10-2.2c-1.7-0.4-3.3,0.9-3.3,2.7c0,1.1,0.7,2.1,1.7,2.5l12.2,5L766.4,778.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M842.2,795.8l-30.3,3.2c-3.4,0.3-6.8-0.3-9.8-2l-31.8-18.1c-3.3-1.6-6.4-3.7-9.2-6.2l-0.1-0.1 c-1.1-1-2.7-1.1-3.9-0.4l-0.1,0.1c-1.7,1-2.1,3.2-1,4.8l12.4,17.8c1.6,2.3,7.1,6.5,9.6,7.8c3.8,1.9,6.7,5.1,8.2,9l3.1,8 c2.3,5.9,9.4,8.4,14.9,5.3l4.2-2.4l34.9,2.2L842.2,795.8z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M806.9,819.4c-0.3,0-0.6,0.1-0.9,0.2l-3.4,1.5c-4.1,2.3-10,0.7-13.8-2.7l0.5,1.3c2.3,5.9,9.4,8.4,14.9,5.3 l4.2-2.4l34.9,2.2l-0.3-6.7L806.9,819.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M913,793l-48.8,20.6c-2.5,1-4,3.4-4,6.1c0,3.7,3,6.6,6.6,6.6h59.8c7,0,12.9-5.3,13.6-12.3l0.7-7.1l14.6-16.8 l-24.6-15.8L913,793z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1203.2,709.7l-134.6-64.2c-12.2-5.8-26.9-2.7-35.7,7.6L927.3,776.4l21.4,19.4l104.4-94.9l99.8,63.3 l45.8-19.8L1203.2,709.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1190.3,721.4c-0.5-0.3-1.2-0.2-1.7,0.3l-14.7,15.9c-1,1-2.5,1.3-3.8,0.7l-105.3-53.4 c-5.5-2.8-12.2-1.8-16.7,2.4L940.9,789l7.8,7l104.4-94.9l99.8,63.3l36.9-15.9l-15.2-7.9l16-17.1 C1191.1,722.8,1191,721.9,1190.3,721.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M1360.6,813.1c0.6,0.1,1.2,0.2,1.8,0.5l21.5,7.9c1.3,0.5,1.9,2.1,1.2,3.3c-0.6,1-1.8,1.4-2.8,1l-19.3-7.6 l-5.6-5.4L1360.6,813.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1360.5,813c0.6,0.1,1.2,0.2,1.8,0.5l21.6,7.9c1.3,0.5,1.9,2.1,1.2,3.3c-0.6,1-1.8,1.4-2.8,1l-19.3-7.6 l-5.6-5.4L1360.5,813z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1232.2,645.7l-5.7,5.5l0.6,1.7c0.6,1.7,0.5,3.5-0.2,5.1l-6.4,13.5c-2,4.2-7.6,5.1-10.8,1.8l-11.3-11.5 l11.3,17.8c1.3,2,2.9,3.6,4.8,4.7c0,0,0,0,0.1,0c0.2,0.1,0.3,0.2,0.5,0.3s0.4,0.2,0.6,0.3s0.3,0.2,0.5,0.2c0.2,0.1,0.5,0.2,0.7,0.3 s0.3,0.1,0.5,0.2c0.2,0.1,0.5,0.2,0.7,0.2c0.1,0,0.1,0,0.2,0.1l0,0c5,1.4,10.7,0.1,14.6-4.1l21-22.4L1232.2,645.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M1317.9,800.8l18.9-8.5l1.1,15.8c0.1,1.2,1,2.2,2.2,2.4l18.1,2.2c1.4,0.2,2.7,0.5,4,1l17.9,7.4 c1.3,0.5,1.9,2.1,1.2,3.4v0.1c-0.6,1.1-1.7,1.6-2.9,1.3c-5.5-1.5-21-5.7-21-5.7l-21.5,5.7c-6.8,2-13.9-2.4-15.2-9.4l-0.4-2.2 L1317.9,800.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1255.3,766.6l-11.6,20c-14.2,24.6-40.4,39.7-68.8,39.7H824v-28.9l334.1-39.5l46-49.1 C1216.1,750.6,1243.7,761.7,1255.3,766.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M1343.5,819.1l11.3,0.9c2.7,0.2,4.8,2.5,4.8,5.2c0,0.7-0.5,1.2-1.2,1.2h-24.6L1343.5,819.1z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1356.5,820.4c-0.5-0.2-1.3-0.3-1.3-0.3l-9.3-0.8c-0.4,0-0.6-0.3-0.6-0.7s0.3-0.6,0.7-0.6l9.3,0.8 c0.1,0,1.4,0.2,2.2,1.3L1356.5,820.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1340.2,810.5l-5.1-0.3c-1.4-0.2-2.4-1.2-2.6-2.6l-0.5-6.3l5.6-0.2l0.4,7.1 C1338,809.4,1339,810.4,1340.2,810.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1325.8,597.2c-0.8-13.7-12.1-24.3-25.8-24.3l-30.8,6.4c-9.7,2-13.5,10.4-17.4,18.9l-3.6,8.3 c-1.9,4-3.1,7.4-6.3,9.8l-4.5,3.5c-7.6,5.5-10.1,14.8-6.9,24l3.1,9.7c0.6,1.7,0.5,3.5-0.2,5.1l-17,36.2 c-2.7,5.8-6.9,10.7-12.2,14.3c-4.2,2.9-5.8,8.3-3.9,13c11.7,28.9,41.4,41,53.6,45.2c2.7,1,5.8-0.2,7.1-2.8l40.7-65.4l16.4,102.9 l19.5-0.8L1325.8,597.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1325.8,597.2c-0.6-11-8.1-20-18-23.1c5.8,5.4,8.1,17.5,8.9,29.5l15.3,197.7l5.6-0.2L1325.8,597.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1222.6,654.9l-4.4,4.3c-0.3,0.3-0.7,0.2-0.9,0c-0.2-0.3-0.2-0.7,0-0.9l4.4-4.3L1222.6,654.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1235.7,759l-10.6,17.4c-10.4,17.5-28.9,28.6-49.3,29.3L824,819v7.2h350.8c28.4,0,54.6-15.1,68.8-39.7 l11.2-19.3C1251.2,766.1,1245.4,764.4,1235.7,759z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1237.9,551.1c0.1,0.4-0.1,0.9-0.5,1l0,0c-1.4,0.6-2.2,2-2,3.5l0,0c0.2,1,0.8,1.9,1.7,2.5 c0.8,0.4,1.6,0.9,1.6,0.9l5.5,9.9c2.5,4.6,8.1,6.5,12.9,4.4l9-3.8l4.9,12.3c0.4,1.1,0.2,2.4-0.5,3.3l-7,9.4 c-3.1,4.1-0.6,10.1,4.5,10.8c5.8,0.8,11.6-1.3,15.6-5.5l24.3-25.8l-14.9-21.6c-3.7-0.6-6.9-2.7-9.1-5.8l-13.7-19.8l-36.1-1.1 L1237.9,551.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1270.3,606.8c-0.9,0-1.7-0.1-2.6-0.2c-2.9-0.4-5.2-2.2-6.4-4.9c-1.1-2.7-0.8-5.7,1-8l7-9.4 c0.4-0.6,0.6-1.4,0.3-2.1l1-1c0.5,1.5,0.7,2.5-0.6,4.6l-5.7,9.4c-1.2,1.6-1.4,3.6-0.7,5.4c0.7,1.8,2.4,3,4.3,3.3 c5.3,0.7,10.7-1.2,14.4-5.1l24.3-25.8l1.9,1.8l-24.3,25.8C1280.7,604.6,1275.6,606.8,1270.3,606.8z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1270.3,606.8c-0.9,0-1.7-0.1-2.6-0.2c-2.9-0.4-5.2-2.2-6.4-4.9c-1.1-2.7-0.8-5.7,1-8l8.4-12.4 c0.9,1.7,0.3,3.2-0.7,4.8l-5.6,9.2c-1.2,1.6-1.4,3.6-0.7,5.4c0.8,1.8,2.4,3.1,4.3,3.3c5.3,0.7,10.7-1.2,14.4-5.1l24.3-25.8 l1.9,1.8l-24.3,25.8C1280.7,604.6,1275.6,606.8,1270.3,606.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1287.5,549.1l-4.7-6l-4.1,6H1287.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1266,569.6l4.9-2.1c0.8-0.3,1.6,0.4,1.2,1.2l-3.2,8.3L1266,569.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1304.8,533.5c-0.1,0-0.2,0-0.2,0c-2.9-0.1-5.2-2.4-5.4-5.2c-0.2-3.3-0.8-6.7-1.8-10.3 c-8.8-29.5-56.7-29.8-63.7,4.3c-0.4,1-0.7,2-0.7,3.1c0,0.5,0,0.9,0,1.3c0,0.2,0,0.3-0.1,0.5c0,0,0,0,0.1,0c0.7,4.6,4.6,8.1,9.3,8.1 c1.8,0,3.5-0.5,4.9-1.4c1.9-1.1,4.3-0.7,5.5,1.2c3.1,4.9,8.5,8.2,14.8,8.2c4,0,7.6-1.3,10.6-3.6c1.5,0.7,3.2,2,4.3,4.2 c-3.4,4.5-5.3,10-5.2,16c0.2,14.3,12.2,26,26.5,25.8c14-0.2,25.4-11.5,25.7-25.5C1329.6,546.2,1318.7,534.3,1304.8,533.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1279.3,549.8c0,0,8.9-4.1,5.9-13.5c-2.9-9.4-14.2-5.1-10.9,4.2l4.1,9.9L1279.3,549.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1280.1,533.3c-1.3-0.1-2.2,0.1-3,0.8c-0.7,0.6-1.1,1.6-1.1,2.8s0.2,2.6,0.9,3.8l0.5,0.9 c0.3,0.7,1.6,0.2,1.2-0.5c-0.5-1-0.5-1-0.5-1c-0.2-0.3-0.8-1.9-0.8-3.1c0-0.9,0.3-1.5,0.7-1.9c0.4-0.4,1.1-0.5,2-0.5 c0.4,0,0.7-0.2,0.7-0.6C1280.7,533.6,1280.5,533.3,1280.1,533.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1240.6,562.7c0,0,2.1-0.8,3.2-3c0.2-0.4,0.6-0.5,1-0.4c0.5,0.2,0.7,0.7,0.4,1.1c-1.2,2.4-3.2,3.4-3.9,3.7 L1240.6,562.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1251.8,598.2l-3.6,8.3c-1.9,4-3.1,7.4-6.3,9.8l6.6-4.3c1.4-0.9,2.5-2.3,3.1-3.9l5.2-18.3l0.6-2.2 C1255.2,590.7,1253.5,594.4,1251.8,598.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1240.5,547.6c1.2,0,2.1-0.9,2.1-2.1c0-1.2-0.9-2.1-2.1-2.1s-2.1,0.9-2.1,2.1S1239.4,547.6,1240.5,547.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1239.6,546.7c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5 C1239.2,546.4,1239.4,546.7,1239.6,546.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1280.3,548c1.1,0,1.9-0.9,1.9-1.9c0-1.1-0.9-1.9-1.9-1.9s-1.9,0.9-1.9,1.9S1279.2,548,1280.3,548z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1280.9,544.3c0.3,0.3,0.5,0.8,0.5,1.3c0,1.1-0.9,1.9-1.9,1.9c-0.2,0-0.4-0.1-0.6-0.1 c0.3,0.4,0.8,0.6,1.4,0.6c1.1,0,1.9-0.9,1.9-1.9C1282.2,545.2,1281.7,544.5,1280.9,544.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1239.2,556.4c-0.3,0-0.6-0.2-0.7-0.5l-3.6-12c-0.1-0.4,0.1-0.8,0.5-0.9s0.8,0.1,0.9,0.5l3.6,12 c0.1,0.4-0.1,0.8-0.5,0.9C1239.3,556.4,1239.2,556.4,1239.2,556.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1237.9,550.6c-0.3,0-0.6-0.2-0.7-0.5c-0.1-0.4,0.1-0.8,0.5-1l35.9-11.8c0.4-0.1,0.8,0.1,1,0.5 c0.1,0.4-0.1,0.8-0.5,1l-35.9,11.8C1238,550.6,1237.9,550.6,1237.9,550.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1318.1,801.8l-0.6-3.5l19.9-0.8l0.2,3.5L1318.1,801.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1313.5,655.6c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6 C1311.8,654.9,1312.6,655.6,1313.5,655.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1257.4,764.1c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6 C1255.7,763.4,1256.5,764.1,1257.4,764.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1257.4,732.7c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6 C1255.7,732,1256.5,732.7,1257.4,732.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1237.2,717.6c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6S1236.3,717.6,1237.2,717.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1218.2,699.2c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6 C1216.5,698.5,1217.3,699.2,1218.2,699.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1308.6,713.9c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6 C1306.9,713.2,1307.7,713.9,1308.6,713.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1291.1,683c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6 C1289.4,682.3,1290.2,683,1291.1,683z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1333.6,788.4c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6S1332.7,788.4,1333.6,788.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1315.9,765.8c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6 C1314.2,765,1315,765.8,1315.9,765.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1329.3,734.3c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6S1328.4,734.3,1329.3,734.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1327.7,686.2c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6S1326.8,686.2,1327.7,686.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1231.3,742.8c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6S1230.4,742.8,1231.3,742.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1264.3,696c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6 C1262.7,695.2,1263.4,696,1264.3,696z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1272.2,663.7c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6S1271.3,663.7,1272.2,663.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1260.7,632c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6S1259.8,632,1260.7,632z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1237.2,690.1c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6S1236.3,690.1,1237.2,690.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1241.9,658.3c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6 C1240.2,657.6,1241,658.3,1241.9,658.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1237.4,627.2c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6 C1235.7,626.5,1236.5,627.2,1237.4,627.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1214.7,654c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6 C1213.1,653.2,1213.8,654,1214.7,654z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1192.5,647.3c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6S1191.6,647.3,1192.5,647.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1184.4,623.8c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6S1183.5,623.8,1184.4,623.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1257.6,601.7c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6S1256.7,601.7,1257.6,601.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1287.5,633.7c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6 C1285.9,632.9,1286.6,633.7,1287.5,633.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1301.6,603.4c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6 C1300,602.6,1300.7,603.4,1301.6,603.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1321,623.8c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6S1320.1,623.8,1321,623.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1207.7,722.5c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6 C1206.1,721.7,1206.9,722.5,1207.7,722.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1281.1,719.2c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6S1280.2,719.2,1281.1,719.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1235.7,759c6.8,3.9,14.1,6.6,18.6,8.1c2.6,0.8,5.4-0.3,6.7-2.7l40.7-65.5l-6-36.8c-0.3-1.8-2.7-2.2-3.6-0.7 L1235.7,759z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M858,215.9c0.1-1.6,0.2-3.3,0.2-4.9c0-40.7-33-73.7-73.7-73.7c-3,0-6,0.2-8.9,0.5 c36.5,4.4,64.9,35.4,64.9,73.2c0,1.7-0.1,3.3-0.2,4.9c19.2,7.9,32.7,26.7,32.7,48.7c0,29.1-23.6,52.6-52.6,52.6h17.8 c29.1,0,52.6-23.6,52.6-52.6C890.7,242.6,877.2,223.8,858,215.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M756.3,612.1c4.5-15.3,7.8-23.1-20.5-40.3s-31.2-40.4-31.2-40.4c-0.1,36.4,19.7,42.8,32.7,61.4 c7.2,10.2,4.2,22.2,2.9,26.3c4.1-17.5-12.3-28.8-12.3-28.8c-23-18.8-25.7-32.6-25.7-32.6c-4.3,24.2,16.1,36.5,22.1,42.6 c13.6,12.2,14,19.5,14,19.4c0.8,5.2-0.5,8.1-1,10.5c-2.4-10.5-11.7-17.2-16.3-21.9c-6.5-6.6-12.4-13.8-17.7-21.5 c-2.4,23.4,19.4,32.9,27.6,41.5c4.3,4.5,4.7,12.9,4.8,16.4c0.1,0.8,0.2,3.4,0.2,4.4c-1-8.1-3.9-12.1-13.6-19.1 c-9.9-7.2-14.5-13-14.5-13c3,19.2,12.7,23.7,19.9,28.2s8.6,11.1,8.6,11.1v-0.2c0.4,3.3,0.9,6.6,1.7,9.9c-3.5-4.1-7.5-6.4-9.7-8 c-5.6-3.9-13.5-11.3-13.5-11.3c6.7,20.7,28.3,38.7,34.9,44.7c0.4,0.5,0.8,0.9,1.3,1.3c-0.2-0.3-0.4-0.8-0.6-1.2 C737.8,666,753.2,622.7,756.3,612.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M853.5,701.4c0,0-2.6-16.3-35.1-8.5c0,0-43.9,5.3-43.7-22c0,0,0.9-48.9,4.7-78.1c3.8-29.3-42.6-31-73.6-73.1 c0,0-10.5,28.5,30.2,54.8c18.7,12.1,34.2,18.1,31.6,25.7c-6.9,20.6-11.5,41.9-14.1,63.5c0,0-4.7,33.9,24.4,40.1 c-30.1,1.7-42.2,11.1-44.6,12.9c-5.9,4.6-14.6,11.8-18.5,18.1c0,0,9.3-6.1,65.2-15.4c37-6.8,72.8-13.7,81.4-1.1 C861.4,718.3,864.4,708,853.5,701.4L853.5,701.4z M841.9,700.5c-1.3,0.1-2.5-0.3-3.5-1.1c-1-0.7-2.1-1.1-3.3-1.4 c1.3,0.2,2.8-0.7,4.1-0.9c1.4-0.2,2.7,0.2,3.8,1c0.9,0.6,1.8,1.7,2.9,1.7C844.6,699.7,843.3,700.4,841.9,700.5L841.9,700.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st24",
    x1: 1144,
    y1: 553.9,
    x2: 1144,
    y2: 546.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 1144,
    y1: 538.2,
    x2: 1144,
    y2: 283.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st24",
    x1: 1144,
    y1: 279.7,
    x2: 1144,
    y2: 272.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st24",
    x1: 1145.5,
    y1: 266.1,
    x2: 1138,
    y2: 266.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 1130,
    y1: 266.1,
    x2: 906.1,
    y2: 266.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st24",
    x1: 902.1,
    y1: 266.1,
    x2: 894.6,
    y2: 266.1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st24",
    x1: 887.6,
    y1: 167.4,
    x2: 882.7,
    y2: 173.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st27",
    x1: 879.2,
    y1: 177.1,
    x2: 871,
    y2: 186.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st24",
    x1: 869.2,
    y1: 188.8,
    x2: 864.3,
    y2: 194.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st24",
    x1: 616.2,
    y1: 191.8,
    x2: 621.1,
    y2: 197.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 624.9,
    y1: 201.8,
    x2: 633.8,
    y2: 212.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st24",
    x1: 635.7,
    y1: 214.4,
    x2: 640.6,
    y2: 220.1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st24",
    x1: 759.3,
    y1: 325,
    x2: 759.1,
    y2: 332.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st29",
    x1: 759,
    y1: 339.1,
    x2: 758.4,
    y2: 373.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st24",
    x1: 758.3,
    y1: 376.7,
    x2: 758.2,
    y2: 384.2
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M1144,511.8L1144,511.8c-1.9,0-3.5-1.6-3.5-3.5v-2.7c0-1.9,1.6-3.5,3.5-3.5l0,0c1.9,0,3.5,1.6,3.5,3.5v2.7 C1147.4,510.2,1145.9,511.8,1144,511.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M1144,394.1L1144,394.1c-1.9,0-3.5-1.6-3.5-3.5v-2.7c0-1.9,1.6-3.5,3.5-3.5l0,0c1.9,0,3.5,1.6,3.5,3.5v2.7 C1147.4,392.5,1145.9,394.1,1144,394.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M1144,300.4L1144,300.4c-1.9,0-3.5-1.6-3.5-3.5v-2.7c0-1.9,1.6-3.5,3.5-3.5l0,0c1.9,0,3.5,1.6,3.5,3.5v2.7 C1147.4,298.8,1145.9,300.4,1144,300.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M1059.2,266.1L1059.2,266.1c0,1.9-1.6,3.5-3.5,3.5h-2.7c-1.9,0-3.5-1.6-3.5-3.5l0,0c0-1.9,1.6-3.5,3.5-3.5 h2.7C1057.6,262.6,1059.2,264.1,1059.2,266.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M945.3,266.1L945.3,266.1c0,1.9-1.6,3.5-3.5,3.5h-2.7c-1.9,0-3.5-1.6-3.5-3.5l0,0c0-1.9,1.6-3.5,3.5-3.5h2.7 C943.8,262.6,945.3,264.1,945.3,266.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphoneFrauOhneGrenzenCombi);
export default __webpack_public_path__ + "static/media/Smartphone_Frau_Ohne_Grenzen_combi.b119986c31a0395a830c2c9a5ae3a588.svg";
export { ForwardRef as ReactComponent };